<template>
  <v-app>
    <Topper v-if="isActiveMenuBar" />
    <Drawer v-if="isActiveMenuBar && windowWidth > 500" />
    <Mobile v-if="isActiveMenuBar && windowWidth <= 500" />
    <v-main class="back-fb ">
      <router-view />
    </v-main>
    <component
      v-for="(component, index) in componentList"
      :key="index"
      :is="component"
    ></component>

    <v-dialog
      v-model="loading"
      width="250"
      height="200"
      persistent
      content-class="elevation-0"
    >
      <div
        class="progress-circular d-flex flex-column justify-center align-center"
      >
        <v-progress-circular
          indeterminate
          :width="6"
          size="120"
          color="white"
        ></v-progress-circular>
        <div class="progress-text mt-5">
          데이터 처리 중입니다.
        </div>
      </div>
    </v-dialog>
  </v-app>
</template>

<script>
import Drawer from "./components/Drawer";
import Mobile from "./components/MobileDrawer";
import Topper from "./components/Topper";
import Snackbar from "./components/Snackbar";
import Alert from "./components/Alert";
import Memo from "./views/memo/Memo";
import Moblie from "./mixin/Mobile";
import SMS from "./components/SMS";
import OrderForm from "./views/modal/OrderForm.vue";
import Confirm from "./components/Confirm.vue";
import MemoList from "./views/memo/MemoList";

import AppSettingAPI from "./api/AppSettingService";
import { checkAndRedirect } from "@/config/redirect";
//import Complete from './views/modal/CompleteInvoice.vue'

export default {
  name: "App",
  mixins: [Moblie],

  components: {
    Drawer,
    Topper,
    Snackbar,
    Alert,
    Memo,
    Mobile,
    SMS,
    OrderForm,
    Confirm,
    MemoList,
    //Complete
  },

  created() {
    /** 특정 도메인/포트로 접속 시 리다이렉트 : 바로바 > 발주입고 경로로 리다이렉트 */
    checkAndRedirect();

    this.$bus.$on("loadingStart", () => {
      this.loading = true;
    });
    this.$bus.$on("loadingEnd", () => {
      this.loading = false;
    });
    this.appSetting();
    if (document.location.href.includes("qrText")) {
      this.$router.push({
        name: "Login",
        params: { qrText: document.location.href.split("qrText=")[1] },
      });
      return;
    }
    if (this.currentPath === "/") {
      if (this.isLogIn) {
        this.$router.push({ name: "ChoiceCon" });
      } else {
        this.$router.push({ name: "Login" });
      }
    }
  },

  mounted() {
    // 추가 보장: 페이지 완전 로드 후 한 번 더 리다이렉트 체크
    this.$nextTick(() => {
      checkAndRedirect();
    });
  },

  data: () => ({
    loading: false,
    componentList: [Snackbar, Alert, Memo, SMS, OrderForm, Confirm, MemoList], //Complete,]
  }),

  computed: {
    menuStatus() {
      return this.$store.state;
    },
    /** Topper, NavBar 활성화 여부 */
    isActiveMenuBar() {
      const disabledPages = ["/login", "/choiceCon"];
      return !disabledPages.includes(this.$route.path);
    },
    currentPath() {
      return this.$route.path;
    },
    isLogIn() {
      return this.$store.getters.getUserList;
    },
  },
  methods: {
    async appSetting() {
      let res = await AppSettingAPI.appSetting();
      this.$store.commit("projectName", res.data.addedSettingInfos.projectName);
    },
  },
};
</script>

<style>
* {
  font-family: "Noto Sans KR";
}
html,
body {
  overflow-y: hidden;
  margin: 0;
}
input {
  outline: none;
}
.border-left-dddddd {
  border-left: 1px solid #dddddd;
}
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 28px !important;
}
.width300-height30 {
  width: 300px !important;
  height: 30px !important;
}
.width179-height30 {
  width: 179px;
  height: 30px !important;
}
.border-text {
  font-family: "Noto Sans KR";
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
}
.btn-ff5b5a {
  color: #ff5b5a !important;
  border-color: #ff5b5a;
  border: 1px solid #ff5b5a !important;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
}
.btn-739eec {
  color: #739eec !important;
  border-color: #739eec !important;
  border: thin solid #739eec;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
}
.border-white {
  border: 1px solid white !important;
  border-color: white !important;
}
.default-btn-text {
  font-family: "Noto Sans KR";
  font-size: 20px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
}
td {
  text-align: center !important;
  padding: 0px !important;
}
th {
  text-align: center !important;
  padding: 0px !important;
  min-width: 60px;
}
.border-btn {
  border: 1px solid #5c5c5c !important;
  background: white !important;
}
.border-5c5c5c {
  border: 1px solid #5c5c5c;
}
.search-text {
  font-family: "Noto Sans KR";
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
}
</style>
<style lang="scss">
.font-12 {
  font-size: 12px !important;
}
.container {
  width: 100% !important;
}
.v-btn__content {
  white-space: normal;
  display: block;
  flex: auto;
}

.back-F7FAFF {
  background: #f7faff;
}

.margin-left-12 {
  margin-left: -12px;
}
.progress-circular {
  // width: 250px !important;
  height: 200px !important;
  // overflow: hidden;
}
.float-left {
  float: left;
}
.width-100 {
  width: 100%;
}
.width-95 {
  width: 95%;
}

.width-50 {
  width: 50%;
}
.width-30 {
  width: 30%;
}
.height-100 {
  height: 100%;
}
.back-white {
  background: white !important;
}
.back-556C96 {
  background: #556c96 !important;
}

.border-right-white {
  border-right: thin solid white !important;
}

.border-left-white {
  border-left: thin solid white !important;
}

.border-top-white {
  border-top: thin solid white !important;
}

.border-aaaaaa {
  border: thin solid #aaaaaa !important;
}

.border-right-aaaaaa {
  border-right: thin solid #aaaaaa !important;
}

.border-left-aaaaaa {
  border-left: thin solid #aaaaaa !important;
}

.border-top-aaaaaa {
  border-top: thin solid #aaaaaa !important;
}

.border-bottom-aaaaaa {
  border-bottom: thin solid #aaaaaa !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.color-white {
  color: white !important;
}

.color-black {
  color: black;
}

.color-5BB1EA {
  color: #5bb1ea;
}

.color-0038FF {
  color: #0038ff;
}

.v-data-table {
  display: block;
}
.theme--light.v-application {
  background: #fbfbfb !important;
}

.v-btn {
  letter-spacing: 0 !important;
  white-space: none !important;
}

table > tbody > tr > td {
  background: white;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input {
  padding-left: 10px;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__mobile-row) {
  background: #ffffff !important;
}
.theme--light.v-data-table {
  background: #fbfbfb !important;
}
/** Scrollbar */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  position: absolute !important;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(194, 197, 202);
  border-radius: 10px;
  background-clip: padding-box;
  border: 2px solid transparent;
}
::-webkit-scrollbar-track {
  background-color: rgb(234, 235, 236);
  border-radius: 10px;
}

.v-row {
  margin: 0px;
}

.max-height-600 {
  max-height: 600px;
}
.required-text {
  font-size: 14px;
  color: red;
}
.v-application .primary--text {
  z-index: 12;
}
//.v-data-table--fixed-header.v-data-table--dense > .v-data-table__wrapper > table > thead > tr:nth-child(3) > th{
//  top:9%
//}
//.v-data-table--fixed-header.v-data-table--dense > .v-data-table__wrapper > table > thead > tr:nth-child(4) > th{
//  top:12%
//}
//.v-data-table--fixed-header.v-data-table--dense > .v-data-table__wrapper > table > thead > tr:nth-child(5) > th{
//  top:16%
//}
.container {
  width: 95% !important;
}

.danger-text {
  font-family: "Noto Sans KR";
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}
@media (max-width: 500px) {
  .v-data-table--fixed-header
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th {
    z-index: 0;
  }
}
.color-red {
  color: red;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: thin solid #aaaaaa;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
  border-bottom: thin solid #aaaaaa !important;
  box-shadow: none;
}
.back-fff4ea {
  background: #fff4ea;
}
.border-555555 {
  border-bottom: thin solid #555555 !important ;
}
</style>
<style scoped>
.v-dialog {
  overflow-y: hidden !important ;
  box-shadow: none !important;
}

.vdialog {
  box-shadow: none !important;
}
.progress-text {
  color: #ffffff;
  text-align: center;
  font-family: "Noto Sans KR";
  font-size: 22px;
  font-weight: 700;
}
</style>
